/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetStoreReviewsAverageRating$Params {
}

export function getStoreReviewsAverageRating(http: HttpClient, rootUrl: string, params?: GetStoreReviewsAverageRating$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: number;
}>> {
  const rb = new RequestBuilder(rootUrl, getStoreReviewsAverageRating.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: number;
      }>;
    })
  );
}

getStoreReviewsAverageRating.PATH = '/api/v1/store-reviews/avg-rating';
